import Layout from "../../components/global/layout"
import { IoCloseCircleOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import loader from "../../methods/loader";
import ApiClient from "../../methods/api/apiClient";
import methodModel from "../../methods/methods";
import CardPreview from "../../components/CardPreview";
import { Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getCheckoutItems } from "../../redux/thunk/checkoutItem";
import { Dialog, DialogPanel } from '@headlessui/react'
import { RxCross2 } from "react-icons/rx";

export default function Checkout() {
    const dispatch: any = useDispatch()
    const checkOutData = useSelector((state: any) => state.checkoutItem.data)
    const [popUp, setPopUp] = useState({ modal: false, cardDetail: {} })
    const [promoCode, setPromoCode]: any = useState({ open: false, code: "", data: "", promoId: "" })

    useEffect(() => {
        dispatch(getCheckoutItems())
    }, [])

    const deleteCheckoutCard = (id: string) => {
        loader(true)
        ApiClient.delete(`cart/remove?id=${id}`).then(res => {
            if (res.success) {
                dispatch(getCheckoutItems())
            }
            loader(false)
        })
    }

    const proceedToCheckout = () => {
        let payload: any = {
            cartIds: checkOutData?.data?.result?.map((item: any) => item?._id)
        }
        if (promoCode?.code) {
            payload = {
                ...payload,
                discountedAmount: promoCode?.data?.discountedAmount || checkOutData?.data?.afterAddTaxPrice,
                promoCode: promoCode?.code,
                promoAmount: Number(promoCode?.data?.discount?.amount_value),
                promotype: promoCode?.data?.discount?.discount_type,
                isPromo: "yes",
                promoId: promoCode?.promoId
            }
        }
        loader(true)
        ApiClient.post(`payNow/payNowOnStripe`, payload).then(res => {
            if (res.success) {
                window.open(res?.data?.url, "_self")
            }
            loader(false)
        })
    }

    const cardPreview = (item: any) => {
        setPopUp({
            modal: true,
            cardDetail: {
                ...item?.customizeCardDetail,
                recipient_name: item?.recipient_name,
                recipient_email: item?.recipient_email,
                sender_name: item?.sender_name,
                sender_nameColor: item?.sender_nameColor,
                sender_nameSize: item?.sender_nameSize,
                receptionTextColor: item?.receptionTextColor,
                receptionTextSize: item?.receptionTextSize,
                receptionTextPosition: item?.receptionTextPosition,
                images: item?.images,
                envelope: item?.envelope,
                audio: item?.audio,
                cartDetail: { capturedImages: item?.capturedImages },
            }
        })
    }

    const blockLeftclick = (e: any) => {
        if (e.button === 0) {
            e.preventDefault();
        }
    };
    document.addEventListener('contextmenu', function (e) {
        e.preventDefault();
    });

    const checkPromoCode = (e: any) => {
        e.preventDefault()
        const payload = {
            code: promoCode?.code,
            totalAmount: checkOutData?.data?.afterAddTaxPrice ? Number(checkOutData?.data?.afterAddTaxPrice) : 0
        }
        loader(true)
        ApiClient.put(`promocode/check/valid/promo`, payload).then(res => {
            if (res.success) {
                setPromoCode({ open: false, code: payload?.code, data: res?.data, promoId: res?.data?.promoId })
            }
            loader(false)
        })
    }

    return (
        <>
            <Layout>
                <div>
                    <div className="section-listinngs px-4 lg:px-16 pt-6 lg:pt-24">
                        <div className="mb-10">
                            <h4 className="text-[30px] text-[#292F36]">Proceed to checkout</h4>
                            <p className="h-1 bg-black/80 w-20"></p>
                        </div>
                        <div className="grid grid-cols-12 gap-4 xl:gap-8">
                            <div className="col-span-12 md:col-span-8">
                                <div className="overflow-auto">
                                    <table className="w-full">
                                        <thead className="bg-[#F6EFE9] mb-4">
                                            <tr className="">
                                                <th className="text-left px-4">Card</th>
                                                <th className="text-left px-4">Name</th>
                                                <th className="text-left px-4">Recipient</th>
                                                <th className="text-left px-4">Price</th>
                                                <th className="text-left px-4"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="">
                                            {checkOutData?.data?.result?.map((item: any, index: number) => {
                                                console.log(item,'==item');                                                
                                                return <tr className="mt-4 border-t border-gray-200" key={index}>
                                                    <td className="px-4 p-4">
                                                        <Tooltip title="Click to preview">
                                                            <img onMouseDown={blockLeftclick} src={methodModel.noImg(item?.images?.["1"])} onClick={e => cardPreview(item)} className="h-20 cursor-pointer" />
                                                        </Tooltip>
                                                    </td>
                                                    <td className="capitalize">{item?.customizeCardDetail?.name}</td>
                                                    <td className="capitalize">{item?.recipient_name}
                                                        <div className="normal-case">{item?.recipient_email || `+${item?.recipient_dialCode} ${item?.recipient_mobileNo}`}</div>
                                                    </td>
                                                    <td>${item?.price}</td>
                                                    <td>
                                                        <Tooltip title="Remove">
                                                            <IoCloseCircleOutline onClick={e => deleteCheckoutCard(item?._id)} className="text-xl cursor-pointer text-red-600" />
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            })}
                                            {checkOutData?.data?.result?.length === 0 &&
                                                <tr className="text-center">
                                                    <td className="px-4 p-4" colSpan={5}>
                                                        No Products
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-4">
                                <div className="bg-[#F6EFE9] p-4 w-full">
                                    <div className="flex items-center justify-between">
                                        <h5 className="border-b-2 border-gray-200 pb-4 font-bold">Total Value</h5>
                                        <h3 className="text-[20px] font-bold">${checkOutData?.data?.totalPrice || 0}</h3>
                                    </div>
                                    <div className="flex justify-between w-full py-4">
                                        <p>Tax</p>
                                        <h3 className="text-[20px] font-bold">6%</h3>
                                    </div>
                                    {promoCode?.data?.discountedAmount &&
                                        <div className="flex justify-between w-full py-4">
                                            <span className="relative">
                                                <p>Promo Code Applied (Discount)</p>
                                                <RxCross2 size={20} onClick={(e: any) => setPromoCode({ open: false, code: "", data: "", promoId: "" })} className="text-red-600 hover:text-red-700 cursor-pointer absolute -top-2 -right-4" />
                                            </span>
                                            <h3 className="text-[20px] font-bold">{promoCode?.data?.discount?.discount_type === "percentage" ? `${promoCode?.data?.discount?.amount_value}%` : `$${promoCode?.data?.discount?.amount_value}`}</h3>
                                        </div>
                                    }
                                    <div className="flex justify-between w-full py-4">
                                        <p>Cart Total</p>
                                        <div className="">
                                            <h3 className="text-[20px] font-bold">${promoCode?.data?.discountedAmount || checkOutData?.data?.afterAddTaxPrice || 0}</h3>
                                        </div>
                                    </div>
                                    <h5 className="border-b-2 border-gray-200 pb-4 font-bold"></h5>
                                    <div>
                                        <span onClick={e => setPromoCode((prev: any) => ({ ...prev, open: true, code: "" }))} className="cursor-pointer hover:underline text-[#f18c18]">Do you have any promo code?</span>
                                    </div>
                                    <div className="btns_big mt-8">
                                        <button type="button" onClick={e => proceedToCheckout()} disabled={checkOutData?.data?.result?.length === 0} className="rounded-full disabled:cursor-not-allowed w-full bg-primary text-white px-4 py-4 text-xl">Proceed To Checkout</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
            <CardPreview popUp={popUp} setPopUp={setPopUp} />

            <Dialog open={promoCode?.open} as="div" className="relative z-10 focus:outline-none" onClose={() => setPromoCode((prev: any) => ({ ...prev, open: false }))}>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-[#0000006b]">
                    <div className="flex min-h-full items-center justify-center overflow-hidden">
                        <DialogPanel transition className="overflow-hidden bg-white w-full h-full max-w-[500px] px-6 py-8 rounded-xl backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0">
                            <form onSubmit={checkPromoCode}>
                                <div className="mb-2">Promo Code</div>
                                <div className="">
                                    <input type="text" value={promoCode?.code} onChange={e => setPromoCode((prev: any) => ({ ...prev, code: e.target.value }))} className="relative shadow-box bg-gray-50 border border-gray-250 w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" placeholder="Enter Promo Code" required />
                                </div>
                                <div className="flex items-center justify-center gap-4 mt-4">
                                    <button type="button" onClick={e => setPromoCode((prev: any) => ({ ...prev, open: false }))} className="rounded-full w-full bg-gray-400 text-white px-2 py-2">Close</button>
                                    <button type="submit" className="rounded-full w-full bg-primary text-white px-2 py-2">Apply</button>
                                </div>
                            </form>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    )
}